/* global Stripe */
// pk_live_v4hsF1UxfEHyEo6kUphYvxUU
// pk_test_QPWG57IdnMw04rG7gncXPZTF
import env from '../config/constants'
var stripe = Stripe(env.stripeKey)

export default {
  ...stripe,
  initializeStripeForm: function(id) {
    var elements = stripe.elements({
      locale: window.__exampleLocale
    })

    // Floating labels
    var inputs = document.querySelectorAll('.cell.stripe .input')
    Array.prototype.forEach.call(inputs, function(input) {
      input.addEventListener('focus', function() {
        input.classList.add('focused')
      })
      input.addEventListener('blur', function() {
        input.classList.remove('focused')
      })
      input.addEventListener('keyup', function() {
        if (input.value.length === 0) {
          input.classList.add('empty')
        } else {
          input.classList.remove('empty')
        }
      })
    })

    var elementStyles = {
      base: {
        color: '#32325D',
        fontWeight: 500,
        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
        fontSize: '16px',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#CFD7DF'
        },
        ':-webkit-autofill': {
          color: '#e39f48'
        }
      },
      invalid: {
        color: '#E25950',

        '::placeholder': {
          color: '#FFCCA5'
        }
      }
    }

    var elementClasses = {
      focus: 'focused',
      empty: 'empty',
      invalid: 'invalid'
    }

    var cardNumber = elements.create('cardNumber', {
      style: elementStyles,
      classes: elementClasses
    })
    cardNumber.mount('#' + id + '-stripe-card-number')

    var cardExpiry = elements.create('cardExpiry', {
      style: elementStyles,
      classes: elementClasses
    })
    cardExpiry.mount('#' + id + '-stripe-card-expiry')

    var cardCvc = elements.create('cardCvc', {
      style: elementStyles,
      classes: elementClasses
    })
    cardCvc.mount('#' + id + '-stripe-card-cvc')

    var ibanNumber = elements.create('iban', {
      style: elementStyles,
      classes: elementClasses,
      supportedCountries: ['SEPA'],
      placeholderCountry: 'IT'
    })
    ibanNumber.mount('#' + id + '-stripe-iban-number')

    return { cardNumber, cardExpiry, cardCvc, ibanNumber }
  }
}



// WEBPACK FOOTER //
// ./src/services/StripeInitializer.js